export default function LifeAgentMark() {
  return (
    <>
      LifeAgent<sup className="inline-block text-[0.45em] align-super origin-bottom scale-y-75 translate-y-[0.35em] tracking-[0.05em] [-webkit-text-stroke:0.04em_currentColor]">TW</sup>
    </>
  );
}
